import EditorModule from '../../remoteContent/EditorModule'

const getEditingPath = (projectId, editorModuleId) => {
  const prod = EditorModule.data.find(item => item.editor_module_id === editorModuleId);
  const url = prod ? prod.friendly_url : '';

  return `/${url}?projectId=${projectId}`;
};

export default getEditingPath;



// WEBPACK FOOTER //
// ./src/Common/Helpers/GetEditingPath.js